/**
 * 订单系统
 *
 */
import Layout from '@/layout'


const workOrderRouter = {
  WorkOrderTagSetting: () => // 垫付/风控任务-垫付需审核司机
    import('@/views/work-order/tag/index.vue'),
}

const workOrderRouters = []
export {
  workOrderRouter,
  workOrderRouters
}
